import { AllLensesTable } from "../components/lenses-table/AllLensesTable";
import { useAllLensesV2 } from "./useAllLensesV2";
import type { ApolloError } from "@apollo/client";

export const AllLensesContainerV2 = () => {
    const { lenses, loading, loadMore, isLastPage, error } = useAllLensesV2();

    return (
        <AllLensesTable
            onLoadMore={loadMore}
            error={error as ApolloError}
            isLoading={loading}
            lenses={lenses}
            isLastPage={isLastPage}
        />
    );
};
